import { Suspense, lazy } from 'react';
import styled from 'styled-components';

import { EditorProps } from './helpers';
import UI from '../UI';
import useInput from '../UI/useInput';

const TiptapEditor = lazy(() => import('./TiptapEditor'));

const EditorFallback = styled(UI.Div)`
  width: 100%;
  min-height: 152px;
  ${useInput}
`;

const Editor = (props: EditorProps) => (
  <Suspense fallback={<EditorFallback style={{ marginBottom: props.variables?.length > 0 ? 42 : 0 }} />}>
    <TiptapEditor {...props} />
  </Suspense>
);

export default Editor;
